import axios from 'axios';

const API_URL = '/api/weather';

export interface CurrentWeather {
    temperature: string;
    humidity: string;
    precipitationType: string;
    rainfall: string;
    windSpeed: string;
}

export interface WeatherForecast {
    date: string;
    time: string;
    temperature: string;
    humidity: string;
    sky: string;
    precipitationType: string;
    rainfall: string;
}

export interface WeatherResponse {
    location: string;
    baseDate: string;
    baseTime: string;
    current: CurrentWeather;
    forecasts: WeatherForecast[];
}

export interface WeatherRegion {
    key: string;
    name: string;
    nx: number;
    ny: number;
}

export const getCurrentWeather = async (region?: WeatherRegion) => {
    const response = await axios.get(`${API_URL}/current`, {
        params: region ? {
            region: region.key,
        } : undefined,
    });
    return response.data as WeatherResponse;
};
